import ReactDOM from "react-dom";

export const SystemModalPortal = ({ children }) => {
  const el = document.getElementById("system-modal");
  return ReactDOM.createPortal(children, el);
};